import { createTheme } from "@mui/material/styles";

export const wixTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f0f4f7",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "18px",
        },
        contained: {
          backgroundColor: "#3899ec",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {},
        filledInfo: {
          border: "1px solid #afafaf",
          backgroundColor: "inherit",
          color: "#0b1f35",
        },
        filledSuccess: {
          border: "1px solid #13a454",
          backgroundColor: "#ebf9f1",
          color: "#0b1f35",
        },
        filledError: {
          border: "1px solid #d91d0b",
          color: "#d91d0b",
          backgroundColor: "#feebea",
        },
      },
    },
  },
});
